<template>
    <div class="stf-heading-two">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
@use '@/assets/sass/_variables' as vars;
@use "bulma/sass/utilities/mixins";

.stf-heading-two {
  font-family: vars.$font-family-primary;
  font-weight: vars.$font-weight-semibold; /* Semi Bold */
  letter-spacing: -0.02em; /* -2% */
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 10px;
  font-size: vars.$font-size-20;

  @include mixins.mobile {
    margin-top: 12px;
    margin-bottom: 7px;
    font-size: vars.$font-size-16;
  }
}
</style>
